function padNumber(num, width) {
  const text = String(num);
  const size = Math.max(1, Number(width) || 1);
  if (text.length >= size) return text;
  return `${"0".repeat(size - text.length)}${text}`;
}

function dateStamp(fmt, date) {
  const year = date.getFullYear();
  const yy = String(year).slice(-2);
  const yyyy = String(year);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const quarter = Math.floor(date.getMonth() / 3) + 1;
  switch (fmt) {
    case "YY":
      return yy;
    case "YYMM":
      return `${yy}${mm}`;
    case "YYMMDD":
      return `${yy}${mm}${dd}`;
    case "YYQ":
      return `${yy}${quarter}`;
    case "YYYYQ":
      return `${yyyy}${quarter}`;
    case "YYYY":
      return yyyy;
    default:
      return `${yy}${mm}`;
  }
}

function joinParts(parts) {
  return {
    text: parts.map((part) => part.text).join(""),
    parts: parts.filter((part) => part.text !== ""),
  };
}

function buildCodeSample(item, draft, date = new Date()) {
  const rule = draft || {};
  if (item?.sourceKind === "derived" || rule.pattern) {
    return {
      text: rule.pattern || item?.pattern || item?.example || "",
      parts: [],
    };
  }
  if (rule.strategy === "userType") {
    const prefix = rule.userTypePrefixes?.CONSULTANT || "T";
    return joinParts([
      { key: "prefix", label: "Consultant prefix", text: prefix },
      { key: "seq", label: "Sequence", text: padNumber(1, rule.numberPad || 1) },
    ]);
  }
  if (rule.strategy === "name") {
    return joinParts([
      { key: "initials", label: "Initials", text: "AB" },
      { key: "seq", label: "Sequence", text: padNumber(1, rule.namePad || 3) },
    ]);
  }
  if (rule.strategy === "provider") {
    return joinParts([
      { key: "provider", label: "Provider code", text: "PROV" },
      { key: "seq", label: "Sequence", text: padNumber(1, rule.numberPad || 4) },
    ]);
  }
  if (rule.method === "SEQUENCE") {
    return joinParts([
      { key: "prefix", label: "Prefix", text: rule.prefix || "" },
      { key: "sep", label: "Separator", text: rule.numberSeperator || "" },
      { key: "seq", label: "Sequence", text: padNumber(1, rule.numberPad || 1) },
    ]);
  }
  if (rule.method === "DATE_SEQUENCE") {
    return joinParts([
      { key: "prefix", label: "Prefix", text: rule.prefix || "" },
      { key: "date", label: rule.dateFmt || "Date", text: dateStamp(rule.dateFmt || "YYMM", date) },
      { key: "sep", label: "Separator", text: rule.numberSeperator || "" },
      { key: "seq", label: "Sequence", text: padNumber(1, rule.numberPad || 1) },
    ]);
  }
  if (rule.method === "RELATION_SEQUENCE" || rule.strategy === "relation") {
    return joinParts([
      { key: "prefix", label: "Prefix", text: rule.prefix || "" },
      { key: "prefixSep", label: "Prefix separator", text: rule.prefixSeparator || "" },
      { key: "parent", label: "Related code", text: "PARENT" },
      { key: "sep", label: "Separator", text: rule.numberSeperator || "" },
      { key: "seq", label: "Sequence", text: padNumber(1, rule.numberPad || 1) },
    ]);
  }
  return { text: "", parts: [] };
}

module.exports = { buildCodeSample, dateStamp, padNumber };
